import React, { useEffect, useState } from 'react'
import styles from './style/up_down_button_style.module.scss';
import PropTypes from 'prop-types';
import Icon, { IconMap } from '../../foundations/icon/Icon'
import { FOUNDATION_PROPTYPES } from '../../foundations/Foundation'

const DEFAULT_ICON_SIZE = 16;

const UpDownButton = ({ style = {}, className = '', onClickUp, onClickDown, disabledUp, disabledDown, ...props }) => {
    return (
        <div className={`${styles.upDownButton} ${className}`} style={style}>
            <div className={`${styles.upButton} ${disabledUp ? styles.disabled : ''}`} onClick={disabledUp ? undefined : onClickUp}>
                <Icon img="chevron_up"
                      size={props.iconSize}
                      {...props}
                />
            </div>
            <div className={`${styles.downButton} ${disabledDown ? styles.disabled : ''}`} onClick={disabledDown ? undefined : onClickDown}>
                <Icon img="chevron_down"
                      size={props.iconSize}
                      {...props}
                />
            </div>
        </div>
    )
}

const PROPTYPES = {
    ...FOUNDATION_PROPTYPES,
    disabledUp: PropTypes.bool,
    disabledDown: PropTypes.bool,
    onClickUp: PropTypes.func.isRequired,
    onClickDown: PropTypes.func.isRequired,
    iconSize: PropTypes.number,
};

UpDownButton.defaultProps = {
    size: DEFAULT_ICON_SIZE
}

UpDownButton.propTypes = PROPTYPES


export default UpDownButton;
